/* Volt theme scripts */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var overlay = $('[data-overlay]');

  // Formats cents with the store's money format, dropping ".00" like Liquid's money_without_trailing_zeros.
  function formatMoney(cents) {
    var format = (window.theme && theme.moneyFormat) || '{{amount}}';
    function group(number, decimals, thousands, decimal) {
      var parts = (number / 100).toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var fraction = parts[1] && parts[1] !== '00' ? decimal + parts[1] : '';
      return whole + fraction;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        default: return group(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Drawers ---------- */
  var openDrawer = null;

  // The sticky header is its own stacking layer (z-index 40), which would trap the menu drawer
  // under the page overlay. Move drawers rendered inside it to <body> so they sit above the overlay.
  function hoistHeaderDrawers() {
    $$('.section-header [data-drawer]').forEach(function (drawer) {
      var previous = drawer.id && document.querySelector('body > #' + drawer.id);
      if (previous && previous !== drawer) previous.remove();
      document.body.appendChild(drawer);
    });
  }
  hoistHeaderDrawers();
  document.addEventListener('shopify:section:load', hoistHeaderDrawers);
  var lockedScrollY = 0;

  // Pins the page in place: overflow:hidden alone is ignored by iOS Safari.
  function lockScroll() {
    if (document.body.classList.contains('is-locked')) return;
    lockedScrollY = window.scrollY;
    document.body.style.top = -lockedScrollY + 'px';
    document.body.classList.add('is-locked');
  }

  function unlockScroll() {
    if (!document.body.classList.contains('is-locked')) return;
    document.body.classList.remove('is-locked');
    document.body.style.top = '';
    window.scrollTo({ top: lockedScrollY, behavior: 'instant' });
  }

  function showDrawer(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) hideDrawer(openDrawer);
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    overlay.hidden = false;
    lockScroll();
    openDrawer = drawer;
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }

  function hideDrawer(drawer) {
    drawer = drawer || openDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.hidden = true;
    unlockScroll();
    // The desktop filter sidebar must stay visible, so only re-hide true drawers.
    if (!drawer.classList.contains('drawer--desktop-static')) {
      setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
    }
    openDrawer = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); showDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) { hideDrawer(); return; }
    var cartOpener = e.target.closest('[data-cart-open]');
    if (cartOpener && theme.cartType === 'drawer' && $('[data-cart-drawer]')) {
      e.preventDefault();
      showDrawer($('[data-cart-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (openDrawer) hideDrawer();
    var search = $('[data-search-panel]');
    if (search && !search.hidden) toggleSearch(false);
  });

  /* ---------- Mobile menu (anker.com-style sliding panels) ---------- */
  function initMobileMenu() {
    var mnav = $('[data-mnav]');
    if (!mnav || mnav.dataset.ready) return;
    mnav.dataset.ready = '1';
    var stack = ['root'];

    function panel(id) { return mnav.querySelector('[data-mnav-panel="' + id + '"]'); }
    function show(id) {
      var current = panel(stack[stack.length - 1]);
      var next = panel(id);
      if (!next || next === current) return;
      current.classList.remove('is-active');
      current.classList.add('is-behind');
      next.classList.remove('is-behind');
      next.classList.add('is-active');
      stack.push(id);
      $$('[data-mnav-products]', next).forEach(function (box) { loadProducts(box); });
      prefetchAhead(next);
    }
    // Fetch the products (and warm the photos) of everything this panel leads to — its expandable
    // sub-categories and the screens its rows open — before the shopper taps one.
    function prefetchAhead(p) {
      $$('[data-mnav-acc]', p).forEach(function (acc) { prefetchProducts(acc.getAttribute('data-mnav-acc')); });
      $$('[data-mnav-open]', p).forEach(function (row) {
        var target = panel(row.getAttribute('data-mnav-open'));
        if (!target) return;
        $$('[data-mnav-products]', target).forEach(function (box) { prefetchProducts(box.getAttribute('data-mnav-products')); });
      });
    }
    // Start fetching a panel's data as soon as a finger touches its row, before the tap completes.
    mnav.addEventListener('pointerdown', function (e) {
      var opener = e.target.closest('[data-mnav-open]');
      var target = opener && panel(opener.getAttribute('data-mnav-open'));
      if (!target) return;
      $$('[data-mnav-products]', target).forEach(function (box) { prefetchProducts(box.getAttribute('data-mnav-products')); });
      prefetchAhead(target);
    }, { passive: true });
    function back() {
      if (stack.length < 2) return;
      // Slide the panel on top away, then reveal the one underneath.
      var current = panel(stack.pop());
      var previous = panel(stack[stack.length - 1]);
      current.classList.remove('is-active', 'is-behind');
      previous.classList.remove('is-behind');
      previous.classList.add('is-active');
    }
    function reset() {
      stack = ['root'];
      $$('[data-mnav-panel]', mnav).forEach(function (p) {
        p.classList.remove('is-behind');
        p.classList.toggle('is-active', p.getAttribute('data-mnav-panel') === 'root');
      });
    }

    mnav.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-mnav-open]');
      if (opener) { show(opener.getAttribute('data-mnav-open')); return; }
      if (e.target.closest('[data-mnav-back]')) back();
    });
    mnav.addEventListener('toggle', function (e) {
      var acc = e.target;
      if (acc.matches && acc.matches('[data-mnav-acc]') && acc.open) loadProducts($('.mnav__products', acc), acc.getAttribute('data-mnav-acc'));
    }, true);
    // Start from the main list each time the menu is opened again.
    new MutationObserver(function () { if (!mnav.classList.contains('is-open')) setTimeout(reset, 300); })
      .observe(mnav, { attributes: true, attributeFilter: ['class'] });
  }

  /* Menu product data: a tiny feed (templates/collection.mnav.liquid), shared between prefetch and
     display, and kept in sessionStorage so categories open instantly on later pages of the visit. */
  var productRequests = {};
  var CACHE_PREFIX = 'mnav:';
  var CACHE_TTL = 10 * 60 * 1000;

  function feedUrl(url) {
    return url.split('?')[0].replace(/\/$/, '') + '?view=mnav';
  }
  function readCache(url) {
    try {
      var hit = JSON.parse(sessionStorage.getItem(CACHE_PREFIX + url));
      if (hit && Date.now() - hit.at < CACHE_TTL) return hit.items;
    } catch (e) {}
    return null;
  }
  function writeCache(url, items) {
    try { sessionStorage.setItem(CACHE_PREFIX + url, JSON.stringify({ at: Date.now(), items: items })); } catch (e) {}
  }
  function warmImages(items) {
    var hiDpi = window.devicePixelRatio > 1.5;
    items.forEach(function (p) {
      var src = hiDpi ? p.i2 || p.i : p.i;
      if (src) { var img = new Image(); img.decoding = 'async'; img.src = src; }
    });
  }
  // Returns a promise of the collection's menu items; each URL is requested only once per page.
  function prefetchProducts(url) {
    if (!url || url.indexOf('/collections/') === -1) return Promise.resolve([]);
    if (productRequests[url]) return productRequests[url];
    var cached = readCache(url);
    if (cached) {
      warmImages(cached);
      productRequests[url] = Promise.resolve(cached);
      return productRequests[url];
    }
    productRequests[url] = fetch(feedUrl(url), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (items) { writeCache(url, items); warmImages(items); return items; })
      .catch(function (err) { delete productRequests[url]; throw err; });
    return productRequests[url];
  }

  // Fills a container with the collection's product cards (once).
  function loadProducts(box, url) {
    url = url || (box && box.getAttribute('data-mnav-products'));
    if (!box || box.dataset.loaded || !url || url.indexOf('/collections/') === -1) return;
    box.dataset.loaded = '1';
    var settled = false;
    // Only show the shimmer if the data isn't already here (avoids a flash when prefetched).
    setTimeout(function () { if (!settled) box.classList.add('is-loading'); }, 80);
    prefetchProducts(url)
      .then(function (items) {
        if (!items.length) {
          box.innerHTML = '<p class="mnav__empty">' + theme.strings.noProducts + '</p>';
          return;
        }
        box.innerHTML = items.map(function (p) {
          var img = p.i ? '<img src="' + p.i + '"' + (p.i2 ? ' srcset="' + p.i + ' 1x, ' + p.i2 + ' 2x"' : '') +
            ' alt="" width="72" height="72" decoding="async">' : '';
          return '<a class="mnav__tile" href="' + p.u + '">' + img +
            '<span class="mnav__tile-text">' + (p.b ? '<span class="mega__badge">' + escapeHtml(p.b) + '</span>' : '') +
            '<span class="mnav__tile-title">' + escapeHtml(p.t) + '</span></span></a>';
        }).join('');
      })
      .catch(function () { delete box.dataset.loaded; })
      .finally(function () { settled = true; box.classList.remove('is-loading'); });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  initMobileMenu();
  document.addEventListener('shopify:section:load', initMobileMenu);

  /* ---------- Mega menu ---------- */
  // Hovering (or focusing) a category in the sidebar shows its products and expands its sub-categories.
  $$('[data-mega]').forEach(function (mega) {
    var links = $$('[data-mega-target]', mega);
    var panels = $$('[data-mega-panel]', mega);
    function activate(link) {
      var target = link.getAttribute('data-mega-target');
      links.forEach(function (l) {
        l.classList.toggle('is-active', l === link);
        var group = l.closest('.mega__group');
        if (group) group.classList.toggle('is-open', l === link);
      });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === target); });
    }
    links.forEach(function (link) {
      var timer;
      link.addEventListener('mouseenter', function () { timer = setTimeout(function () { activate(link); }, 60); });
      link.addEventListener('mouseleave', function () { clearTimeout(timer); });
      link.addEventListener('focus', function () { activate(link); });
    });
  });

  /* ---------- Announcement rotator ---------- */
  $$('[data-rotator]').forEach(function (rotator) {
    var items = $$('.announcement__msg', rotator);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, parseInt(rotator.dataset.interval, 10) || 5000);
  });

  /* ---------- Search ---------- */
  function toggleSearch(force) {
    var panel = $('[data-search-panel]');
    if (!panel) return;
    var show = typeof force === 'boolean' ? force : panel.hidden;
    panel.hidden = !show;
    $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', show); });
    if (show) $('[data-predictive-input]', panel).focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); toggleSearch(); }
  });

  var predictiveInput = $('[data-predictive-input]');
  var predictiveResults = $('[data-predictive-results]');
  if (predictiveInput && predictiveResults) {
    var timer;
    predictiveInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = predictiveInput.value.trim();
      if (q.length < 2) { predictiveResults.innerHTML = ''; return; }
      timer = setTimeout(function () {
        // Server-rendered so prices and labels follow the store's currency and language settings.
        fetch(theme.routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var section = doc.querySelector('.shopify-section');
            predictiveResults.innerHTML = section ? section.innerHTML.trim() : '';
          })
          .catch(function () { predictiveResults.innerHTML = ''; });
      }, 250);
    });
  }

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var slides = $$('[data-slide]', slider);
    var dots = $$('[data-slider-dot]', slider);
    if (slides.length < 2) return;
    var current = 0;
    var timer = null;
    var interval = parseInt(slider.dataset.interval, 10) || 6000;

    function go(i) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function start() {
      if (slider.dataset.autoplay !== 'true') return;
      stop();
      timer = setInterval(function () { go(current + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); }

    var prev = $('[data-slider-prev]', slider);
    var next = $('[data-slider-next]', slider);
    if (prev) prev.addEventListener('click', function () { go(current - 1); start(); });
    if (next) next.addEventListener('click', function () { go(current + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.sliderDot, 10)); start(); }); });

    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); start(); }
      startX = null;
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    // Pause in the theme editor when a block is selected.
    document.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target);
      if (idx > -1) { stop(); go(idx); }
    });
    start();
  });

  /* ---------- Horizontal scrollers ---------- */
  function initScroller(scroller) {
    var track = $('[data-scroller-track]', scroller);
    var prev = $('[data-scroller-prev]', scroller);
    var next = $('[data-scroller-next]', scroller);
    if (!track || !prev || !next) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    // Optional page dots (category cards on phones): one dot per screen-width page.
    var dots = $('[data-scroller-dots]', scroller);
    function buildDots() {
      if (!dots) return;
      var pages = track.clientWidth ? Math.round(track.scrollWidth / track.clientWidth) : 1;
      if (pages < 2) { dots.innerHTML = ''; return; }
      if (dots.children.length !== pages) {
        dots.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Page ' + (i + 1));
          dot.addEventListener('click', (function (n) { return function () { track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); }; })(i));
          dots.appendChild(dot);
        }
      }
      var current = Math.round(track.scrollLeft / track.clientWidth);
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === current); });
    }
    if (dots) {
      track.addEventListener('scroll', buildDots, { passive: true });
      window.addEventListener('resize', buildDots);
      buildDots();
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  $$('[data-scroller]').forEach(initScroller);

  /* ---------- Equal-height card titles ---------- */
  // Cards that sit on the same visual row get the height of the tallest title, so prices line up.
  function equalizeCardTitles() {
    var titles = $$('.card__title');
    titles.forEach(function (t) { t.style.minHeight = ''; });
    var rows = {};
    titles.forEach(function (t) {
      var card = t.closest('.card');
      if (!card || !card.offsetParent) return;
      var list = card.closest('ul') || document.body;
      var key = (list.dataset.eqId || (list.dataset.eqId = Math.random().toString(36).slice(2))) + ':' + Math.round(card.getBoundingClientRect().top + window.scrollY);
      (rows[key] = rows[key] || []).push(t);
    });
    Object.keys(rows).forEach(function (key) {
      var group = rows[key];
      if (group.length < 2) return;
      var max = Math.max.apply(null, group.map(function (t) { return t.getBoundingClientRect().height; }));
      group.forEach(function (t) { t.style.minHeight = max + 'px'; });
    });
  }
  var eqTimer;
  function scheduleEqualize() {
    clearTimeout(eqTimer);
    eqTimer = setTimeout(equalizeCardTitles, 60);
  }
  scheduleEqualize();
  window.addEventListener('resize', scheduleEqualize);
  window.addEventListener('load', scheduleEqualize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleEqualize);

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var buttons = $$('[data-tab]', wrap);
    var panels = $$('[data-tab-panel]', wrap);
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.dataset.tab, 10);
        buttons.forEach(function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-selected', j === i); });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        scheduleEqualize();
        var s = $('[data-scroller]', panels[i]);
        if (s) { var t = $('[data-scroller-track]', s); t.dispatchEvent(new Event('scroll')); }
      });
    });
  });

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartDrawer(html, open) {
    var current = $('[data-cart-drawer]');
    if (!current || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    current.innerHTML = fresh.innerHTML;
    current.dataset.itemCount = fresh.dataset.itemCount;
    updateCartCount(parseInt(fresh.dataset.itemCount, 10) || 0);
    if (open) showDrawer(current);
  }

  function hasDrawer() { return theme.cartType === 'drawer' && !!$('[data-cart-drawer]'); }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var button = $('[data-add-button]', form);
    var errorEl = $('[data-form-error]', form);
    var label = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.textContent = theme.strings.adding; }
    if (errorEl) errorEl.hidden = true;

    var body = new FormData(form);
    if (hasDrawer()) body.append('sections', 'cart-drawer');

    fetch(theme.routes.cart_add_url + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Error');
        if (hasDrawer() && res.data.sections) {
          renderCartDrawer(res.data.sections['cart-drawer'], true);
        } else {
          window.location.href = theme.routes.cart_url;
        }
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else alert(err.message);
      })
      .finally(function () { if (button) { button.disabled = false; button.innerHTML = label; } });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var line = btn.closest('[data-line]');
    if (!line) return;
    line.classList.add('is-loading');
    var payload = { line: parseInt(line.dataset.line, 10), quantity: parseInt(btn.dataset.qtyChange, 10) };
    var inPage = !!btn.closest('[data-cart-page]');
    if (!inPage && hasDrawer()) payload.sections = 'cart-drawer';

    fetch(theme.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (inPage) { window.location.reload(); return; }
        if (data.sections) renderCartDrawer(data.sections['cart-drawer'], false);
        else updateCartCount(data.item_count);
      })
      .catch(function () { window.location.reload(); });
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (section) {
    var gallery = $('[data-gallery]', section);
    var slides = gallery ? $$('.gallery__slide', gallery) : [];
    var thumbs = gallery ? $$('[data-thumb]', gallery) : [];

    function showMedia(id) {
      var found = false;
      slides.forEach(function (s) {
        var match = String(s.dataset.mediaId) === String(id);
        s.classList.toggle('is-active', match);
        if (match) found = true;
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        var match = String(t.dataset.thumb) === String(id);
        t.classList.toggle('is-active', match);
        if (match) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
    }
    function stepMedia(dir) {
      var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      var nextSlide = slides[(idx + dir + slides.length) % slides.length];
      if (nextSlide) showMedia(nextSlide.dataset.mediaId);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });
    var gPrev = $('[data-gallery-prev]', section);
    var gNext = $('[data-gallery-next]', section);
    if (gPrev) gPrev.addEventListener('click', function () { stepMedia(-1); });
    if (gNext) gNext.addEventListener('click', function () { stepMedia(1); });
    if (gallery) {
      var sx = null;
      gallery.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) stepMedia(dx < 0 ? 1 : -1);
        sx = null;
      });
    }

    // Quantity stepper
    $$('[data-qty-step]', section).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
      });
    });

    // Variant picker
    var picker = $('[data-variant-picker]', section);
    var addButtons = $$('[data-add-button], [data-sticky-atc-button]', section.parentElement);
    if (picker) {
      var variants = JSON.parse($('[data-variants]', picker).textContent);
      var fieldsets = $$('fieldset', picker);

      function getSelected() {
        return fieldsets.map(function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }
      function findVariant(selected) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
      }

      // Cross out a value only when no in-stock variant has it together with the options chosen above it
      // (e.g. a colour is crossed only if sold out in every size; sizes reflect the chosen colour).
      function updateAvailability(selected) {
        fieldsets.forEach(function (fs, i) {
          $$('input[type="radio"]', fs).forEach(function (input) {
            var inStock = variants.some(function (v) {
              return v.available && v.options[i] === input.value && v.options.every(function (o, j) {
                return j >= i || o === selected[j];
              });
            });
            var label = input.closest('label');
            label.classList.toggle(label.classList.contains('swatch') ? 'swatch--unavailable' : 'pill--unavailable', !inStock);
          });
        });
      }

      // Updates the main and sticky prices instantly from the variant data (no server round trip).
      function updatePrices(variant) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        $$('[data-price]', section.parentElement).forEach(function (el) {
          var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
          if (onSale) {
            var savings = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' +
              '<span class="price__badge">-' + savings + '%</span>';
          }
          el.innerHTML = html;
          el.classList.toggle('price--on-sale', !!onSale);
        });
      }

      updateAvailability(getSelected());

      picker.addEventListener('change', function (e) {
        var selected = getSelected();
        var changedIndex = fieldsets.indexOf(e.target.closest('fieldset'));
        var match = findVariant(selected);

        // If the new choice makes the combination sold out, switch the other options to an in-stock one.
        if ((!match || !match.available) && changedIndex > -1) {
          var alternative = variants.find(function (v) {
            return v.available && v.options[changedIndex] === selected[changedIndex];
          });
          if (alternative) {
            alternative.options.forEach(function (value, i) {
              $$('input[type="radio"]', fieldsets[i]).forEach(function (input) { input.checked = input.value === value; });
            });
            selected = alternative.options.slice();
          }
        }

        updateAvailability(selected);
        selected.forEach(function (v, i) {
          var label = $('[data-option-value="' + i + '"]', picker);
          if (label) label.textContent = v;
        });
        var variant = findVariant(selected);
        var idInput = $('[data-variant-id]', section);

        if (!variant) {
          addButtons.forEach(function (b) { b.disabled = true; b.textContent = theme.strings.unavailable; });
          return;
        }
        if (idInput) idInput.value = variant.id;
        addButtons.forEach(function (b) {
          b.disabled = !variant.available;
          b.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        });
        if (variant.featured_media) showMedia(variant.featured_media.id);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        updatePrices(variant);
      });
    }

    // Sticky add to cart
    var sticky = document.querySelector('[data-sticky-atc]');
    var mainAdd = $('.product-form__add', section);
    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainAdd);
      $('[data-sticky-atc-button]', sticky).addEventListener('click', function () {
        mainAdd.click();
      });
    }
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (!el.dataset.url || el.querySelector('.product-row')) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          $$('[data-scroller]', el).forEach(initScroller);
          scheduleEqualize();
        }
      });
  });

  /* ---------- Collection filters & sorting ---------- */
  function submitFilters() {
    var params = new URLSearchParams();
    $$('[data-filter-form]').forEach(function (form) {
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
    });
    window.location.search = params.toString();
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-auto-submit]')) submitFilters();
  });
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(); });
  });
})();
